"use client"
import React, { useState, useEffect } from "react";
import { Navbar, Nav, NavDropdown, Form } from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import UralityAvatarImage from "@/components/shared/UralityAvatarImage";
import useApi from "@/components/api/useApi";
import { useMediaQuery } from "react-responsive";
import SetPasswordHeader from "@/components/onboarding/SetPasswordHeader";
import { useConfig } from "@/lib/providers/ConfigProvider";
import { PORTAL_TYPES } from "@/components/portals/portalTypes";

import "@/components/shared/Header.css";

const Header = ({
  name,
  profile,
  className,
  show = true,
  condensed,
  onboarding,
  branded,
  showPasswordBanner = false
}) => {
  const { webUrl } = useConfig();
  const [showCreate, setShowCreate] = useState(true);
  const [navbarExpanded, setNavbarExpanded] = useState(false);

  const isSm = useMediaQuery({ query: "(max-width: 767.98px)" });

  const api = useApi();

  const [authenticatedProfile, setAuthenticatedProfile] = useState(null);

  useEffect(() => {
    api
      .getAuthenticatedProfileForEdit()
      .then(auth => {
        setAuthenticatedProfile(auth);
      })
      .catch(error => {
        // setLoading(false);
      });
  }, []);

  return (
    <>
      <div
        className={`navbar-header-wrapper ${className ?? ""} ${
          show ? "show" : "hide"
        }`}
      >
        <Navbar
          sticky="top"
          collapseOnSelect
          expand="md"
          style={{ margin: "0 auto" }}
          expanded={navbarExpanded}
          onToggle={expanded => {
            setNavbarExpanded(!navbarExpanded);
            // this should only run on mobile, and is not referenced in the desktop layout.
            setShowCreate(!expanded);
          }}
        >
          <Navbar.Brand>
            <div
              className={`navbar-brand-logo${condensed ? " condensed" : ""}${
                branded ? " branded" : ""
              }`}
            />
          </Navbar.Brand>

          {!isSm && (
            <>
              {authenticatedProfile && !onboarding && (
                <>
                  <Navbar.Collapse className="show justify-content-end">
                    <div className="vertical-separator" />
                    <div className="owner-profile">
                      <a href={`${webUrl}account`}>
                        <UralityAvatarImage
                          imageId={authenticatedProfile.logoId}
                          size="sm"
                          name={authenticatedProfile.label}
                          type={authenticatedProfile.userProfileType}
                        />
                      </a>
                      <NavDropdown
                        // alignRight
                        className="profile-menu-dropdown"
                        title={authenticatedProfile.label}
                      >
                        {authenticatedProfile &&
                          authenticatedProfile.userProfileType ===
                            "COMMUNITY" && (
                            <NavDropdown.Item
                              key="my_community"
                              href={
                                webUrl +
                                authenticatedProfile.resourceName +
                                "/community"
                              }
                            >
                              My Community Hub
                            </NavDropdown.Item>
                          )}

                        {authenticatedProfile &&
                          authenticatedProfile.community &&
                          authenticatedProfile.community
                            ?.volunteerManagementEnabled && (
                            <NavDropdown.Item
                              key="my_community"
                              href={
                                webUrl +
                                authenticatedProfile.community?.owner
                                  ?.resourceName +
                                "/portal"
                              }
                            >
                              Go to Portal
                            </NavDropdown.Item>
                          )}

                        {authenticatedProfile &&
                          authenticatedProfile.community?.enabledPortalTypes?.includes(
                            authenticatedProfile.userProfileType
                          ) && (
                            <NavDropdown.Item
                              key="profile_portal"
                              href={
                                webUrl +
                                authenticatedProfile.resourceName +
                                "/portals/" +
                                authenticatedProfile.userProfileType.toLowerCase()
                              }
                            >
                              {PORTAL_TYPES[authenticatedProfile.userProfileType]?.portalLabel ?? "Portal"}
                            </NavDropdown.Item>
                          )}

                        <NavDropdown.Divider />
                        {profile && (
                          <NavDropdown.Item
                            href={`/${profile.resourceName}/logout`}
                          >
                            Log Out
                          </NavDropdown.Item>
                        )}
                        <NavDropdown.Divider />
                        <div className="minimized-links">
                          <a
                            href={"https://urality.com"}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            About Urality
                          </a>
                          <br />
                          <a
                            href={"https://urality.com/terms-of-use"}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Terms
                          </a>
                          <span> + </span>
                          <a
                            href={"https://urality.com/privacy-policy"}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Privacy
                          </a>
                        </div>
                      </NavDropdown>
                      {/* <AppNotificationButton
                        name={authenticatedProfile.resourceName}
                      /> */}
                    </div>
                  </Navbar.Collapse>
                </>
              )}
            </>
          )}
          {isSm && (
            <>
              <div className="flex-grow" />

              {!authenticatedProfile && (
                <>
                  <Navbar.Toggle aria-controls="offcanvasNavbar" />
                  <Navbar.Offcanvas
                    id="offcanvasNavbar"
                    aria-labelledby="offcanvasNavbarLabel"
                    placement="end"
                    expand={false}
                  >
                    <Offcanvas.Header closeButton>
                      <Offcanvas.Title id="offcanvasNavbarLabel"></Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                      <div className="options">
                        {profile && (
                          <Nav.Link href={`${profile.resourceName}/logout`}>
                            Log Out
                          </Nav.Link>
                        )}
                        <Nav.Link
                          href={"https://urality.com"}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          About Urality
                        </Nav.Link>
                        <Nav.Item className="terms-and-privacy">
                          <Nav.Link
                            href={"https://urality.com/terms-of-use"}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Terms
                          </Nav.Link>
                          <span> + </span>
                          <Nav.Link
                            href={"https://urality.com/privacy-policy"}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Privacy
                          </Nav.Link>
                        </Nav.Item>
                      </div>
                    </Offcanvas.Body>
                  </Navbar.Offcanvas>
                </>
              )}
              {authenticatedProfile && (
                <>
                  <div
                    className="new-content-button-container"
                    style={{ display: showCreate ? "flex" : "none" }}
                  >
                    {/* {authenticatedProfile.userProfileType === "COMMUNITY" && (
                      <AppNotificationButton
                        name={authenticatedProfile.resourceName}
                      />
                    )} */}
                  </div>
                  <div
                    className={`vertical-separator ${showCreate ? "" : "hide"}`}
                  />

                  <>
                    <Navbar.Toggle aria-controls="offcanvasNavbar" />
                    <Navbar.Offcanvas
                      id="offcanvasNavbar"
                      aria-labelledby="offcanvasNavbarLabel"
                      placement="end"
                      expand={false}
                    >
                      <Offcanvas.Header closeButton>
                        <Offcanvas.Title id="offcanvasNavbarLabel">
                          {authenticatedProfile && (
                            <a href={`${webUrl}account`}>
                              <UralityAvatarImage
                                imageId={authenticatedProfile.logoId}
                                size="sm"
                                name={authenticatedProfile.label}
                                type={authenticatedProfile.userProfileType}
                              />
                              <Navbar.Text>
                                {authenticatedProfile.label}
                              </Navbar.Text>
                            </a>
                          )}
                        </Offcanvas.Title>
                      </Offcanvas.Header>
                      <Offcanvas.Body>
                        {authenticatedProfile && (
                          <>
                            {/*{mobileDashboardMenu()}*/}
                            <div style={{ marginBottom: "2rem" }} />
                          </>
                        )}
                        <div className="options">
                          {profile && (
                            <Nav.Link href={`${profile.resourceName}/logout`}>
                              Log Out
                            </Nav.Link>
                          )}
                          <Nav.Link
                            href={"https://urality.com"}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            About Urality
                          </Nav.Link>
                          <Nav.Item className="terms-and-privacy">
                            <Nav.Link
                              href={"https://urality.com/terms-of-use"}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Terms
                            </Nav.Link>
                            <span> + </span>
                            <Nav.Link
                              href={"https://urality.com/privacy-policy"}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Privacy
                            </Nav.Link>
                          </Nav.Item>
                        </div>
                      </Offcanvas.Body>
                    </Navbar.Offcanvas>
                  </>
                </>
              )}
            </>
          )}
        </Navbar>
      </div>
      {authenticatedProfile &&
        showPasswordBanner && (
          <SetPasswordHeader
            show={showPasswordBanner}
            profile={authenticatedProfile}
          />
        )}
    </>
  );
};
export default Header;
